<script lang="ts" setup>
// Extrémité gauche du header : accès au menu en tiroir (sous `md`), logo, et
// les cloches — qui n'ont leur place ici que sur mobile, la barre desktop
// (`HeaderNav`) les affichant à droite de la navigation.
const drawerOpen = ref(false)

function openDrawer() {
  drawerOpen.value = true
}
</script>

<template>
  <div class="flex items-center w-full md:w-52">
    <button
      class="md:hidden pr-2 cursor-pointer"
      aria-label="Ouvrir le menu"
      @click="openDrawer"
    >
      <Icon
        name="lucide:menu"
        class="h-4 w-4"
        aria-hidden="true"
      />
    </button>
    <div class="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />

    <HeaderLogo class="w-28 md:w-42" />

    <NotificationBadges class="ml-auto md:hidden" />

    <HeaderMobileDrawer v-model:open="drawerOpen" />
  </div>
</template>
